import { render, staticRenderFns } from "./scanQR.vue?vue&type=template&id=11320fcb"
import script from "./scanQR.vue?vue&type=script&lang=js"
export * from "./scanQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports